const shape = {
    borderRadius: 8
}

export default shape;